// extracted by mini-css-extract-plugin
module.exports = {"root":"History_root__1ZMwh","items_wrapper":"History_items_wrapper__1LdOK","empty-history":"History_empty-history__F3v-J","btn":"History_btn__2wi4K"};